const KeenSlider = window.KeenSlider

const { setInitialised } = window.BAO.Carousel.plugins

class UspCarousel extends window.BAO.CustomElement() {
  static get requiredElements () {
    return ['slides', 'slide']
  }

  connectedCallback () {
    super.connectedCallback()

    this.carousel = this.setupCarousel()
  }

  setupCarousel () {
    return new KeenSlider(
      this.els.slides.element,
      {
        selector: this.els.slide.selector,
        loop: false,
        mode: 'snap',
        slides: {
          perView: 1.4,
          spacing: 50,
        },
        breakpoints: {
          '(min-width: 768px)': {
            slides: {
              perView: 2.6,
              spacing: 50,
            },
          },
          '(min-width: 901px)': {
            slides: {
              perView: 4,
              spacing: 50,
            },
          },
        },
      },
      [setInitialised()],
    )
  }
}

if (!customElements.get('section-usp')) {
  customElements.define('section-usp', UspCarousel)
}
